import api from "./api";

export const GetEngagementScore = async (opportunity_ids: Array<string>) => {
	return api
		.post("/get_engagement_scores", {
			opportunity_ids,
		})
		.then((res) => res.data.engagement_scores);
};
